import { IVehicle } from "../../models/Vehicle";


export default function VehicleCodCell({ vehicle }: { vehicle: IVehicle }) {
  var className = "rounded-full px-3 py-1 text-xs font-semibold ";
  var statusText = "No COD";

  if (vehicle.codRequired) {
    if (vehicle.codConfirmedOn) {
      className += "bg-green-100 text-green-600";
      statusText = "COD Confirmed";
    } else {
      className += "bg-yellow-100 text-yellow-600";
      statusText = "COD Required";
    }
  } else {
    className += "bg-gray-100 text-gray-800";
  }

  return (
    <div title="COD Status" className="flex justify-center items-center flex-1 text-nowrap">
      <span className={className}>{statusText}</span>
    </div>
  );
};